export default "__VITE_ASSET__8d570d4a__"